import React, { useContext, useEffect, useState } from 'react';
import { 
  Col, 
  Container, 
  Row, 
  Form, 
} from 'react-bootstrap';
import toast from 'react-hot-toast';
import { Button, ButtonGroup } from '@/shared/components/Button';
import { FaExclamationCircle } from 'react-icons/fa';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { RestaurantContext } from '../../../../../context/RestaurantContext';
import RejectedRequestCard from './RejectedRequestCard';
import ProgressBar from '../../../Loader';
import { GlobalVarContext } from '../../../../../context/GlobalVarContext';
import { AuthContext } from '../../../../../context/AuthContext';
import { Mealcontext } from '../../../../../context/MealContext';
import { SideBarRefreshContext } from '../../../../../context/SideBarRefreshContext';

const RejectedRequest = () => {
  const [rejectedMeal, setRejectedMeal] = useState([]);
  const [filterMeal, setFilterMeal] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const { refresh, setRefresh } = useContext(Mealcontext);
  const [isLoading, setIsLoading] = useState(false);
  const { apiGlobal } = useContext(GlobalVarContext);
  const { restaurantid } = useContext(AuthContext);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);



  const fetchData = async () => {
    setIsLoading(true);
     const formdata = new FormData();
    formdata.append('restaurant_id', restaurantid);
    try {
      const response = await fetch(`${apiGlobal}restaurant/meal_reject_list.php`, {
        method: 'POST',
        body: formdata,
      });
      const data = await response.json();
  
      // console.log('Data:', data);
  
      if (data.status && data.message === 'Success') {
        console.log('Data fetched:', data.data);
        setRejectedMeal(data.data);
        setFilterMeal(data.data);
      } else {
        console.log('No data fetched');
        setFilterMeal([]);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error('Failed to load data');
    } finally {
      setIsLoading(false);
    }
  };
  


  useEffect(() => {
    console.log('Refreshing data...');
    fetchData();
  }, [refresh, sideBarRefresh?.restaurantMealRejectedRefresh]);
  
  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          // justifyContent: 'center', // Center horizontally
          // alignItems: 'center', // Center vertically
          height: '100vh', // Full viewport height
        }}
      >
        <ProgressBar />
      </div>
    );
  }
  

  // if (rejectedMeal.length <= 0) {
  //   return (
  //     <div>
  //       No meal Found
  //     </div>
  //   );
  // }
  
  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query) {
      const filteredData = rejectedMeal
      .filter(mealData => mealData.name.toLowerCase().includes(query.toLowerCase()));
        setFilterMeal(filteredData);
    } else {
      setFilterMeal(rejectedMeal);
    }
  };

  const refreshHandler = () => {
    fetchData();
    setSearchQuery('');
    // toast.success('Refresh....');
  };

  return (
    <div>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
      marginBottom: '5px',
    }}
      >
        <Typography sx={{ color: 'text.primary' }}>Restaurant</Typography>
        <Typography sx={{ color: 'text.primary' }}>Meal</Typography>
        <Typography sx={{ color: 'text.primary' }}>Rejected Request</Typography>
      </Breadcrumbs>
      <Container className="bg-white" style={{ padding: '20px' }}>
        <div style={{
             display: 'flex', width: '25%', marginBottom: '10px', marginTop: '10px', alignItems: 'center',
                          }}
        >
          <Form.Control
            type="text"
            placeholder="Search by Name......"
            value={searchQuery}
            onChange={handleSearch}
            style={{
                                height: '30px',
                                marginTop: '5px',
                                borderColor: 'green',
                                flexGrow: 1,
                              }}
          />
         
          <ButtonGroup icons dir="ltr" style={{ marginTop: '10px' }}>
            <Button
              variant="outline-secondary"
              title="Refresh"
              size="sm"
              style={{ marginLeft: '10px' }}
              onClick={refreshHandler}
            >
              <span className="lnr lnr-sync" />
            </Button>
          </ButtonGroup>
               
        </div>
        {/* <Row>
        <div className="col-md-4 mb-4 d-flex align-items-center">
          <Form.Control
            type="text"
            placeholder="Search by Name"
            value={searchQuery}
            onChange={handleSearch}
            className="flex-grow-1"
            style={{
              backgroundColor: currentTheme === 'Dark' ? '#232329' : 'white',
              color: currentTheme === 'Dark' ? 'white' : 'black',
            }}
          />
        </div>
      </Row> */}
        <Row>
          <Container>
            {filterMeal.length > 0 ? (
            filterMeal.map(resData => (
              <RejectedRequestCard
                key={resData.id}
                id={resData.id}
                mealName={resData.name}
                resName={resData.restaurant_name}
                remark={resData.reject_reason}
                photo={resData.photo}
                // setRefresh={setRefresh}
              />
            ))
          ) : (
                            // If search results are empty
            <div style={{
                  textAlign: 'center',
                  padding: '50px',
                  backgroundColor: '#f8d7da',
                  borderRadius: '8px',
                  marginTop: '20px',
                  color: '#721c24',
                  fontSize: '16px',
                          }}
            >
              <FaExclamationCircle style={{ fontSize: '48px', marginBottom: '20px' }} />
              <p>{searchQuery ? 'No results found for your search' : 'No requests available'}</p>
            </div>
                          )}
          </Container>
        </Row>
      </Container>
    </div>
   
  );
};

export default RejectedRequest;
